import { render, staticRenderFns } from "./RmpDetailsSubheader.vue?vue&type=template&id=38e8f06e&scoped=true"
import script from "./RmpDetailsSubheader.vue?vue&type=script&setup=true&lang=ts"
export * from "./RmpDetailsSubheader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e8f06e",
  null
  
)

export default component.exports